import { createFileRoute } from '@tanstack/react-router';
import { OverviewPage } from '@/features/platform/overview-page';

export const Route = createFileRoute('/_app/_platform/')({
    staticData: { crumbs: [{ label: 'shell.overview' }] },
    // `?notifications=1` opens the complete notification list on the home page.
    validateSearch: (search: Record<string, unknown>): { notifications?: 1 } =>
        search.notifications === 1 || search.notifications === '1' || search.notifications === true
            ? { notifications: 1 }
            : {},
    component: function HomeRoute() {
        const { notifications } = Route.useSearch();
        return <OverviewPage showNotifications={notifications === 1} />;
    },
});
